import { render, staticRenderFns } from "./StudentListDt.vue?vue&type=template&id=712f76d4&"
import script from "./StudentListDt.vue?vue&type=script&lang=js&"
export * from "./StudentListDt.vue?vue&type=script&lang=js&"
import style0 from "./StudentListDt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports